import ToastUI from "@UI/ToastUI";

import { computed } from "mobx";
import { inject, observer } from "mobx-react";

import { ConfirmDialog } from "primereact/confirmdialog";

import { ConfirmPopup } from "primereact/confirmpopup";

import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

import { Editor } from "primereact/editor";
import Loader from "./components/Loader";
import Auth from "./containers/Auth";
import Modals from "./containers/Modals";
import Pages from "./containers/Pages";

const Root = inject("mainStore")(
    observer(({ mainStore }) => {
        const auth = computed(() => mainStore.getMainStore("auth")).get();

        const Specified = !auth ? Auth : Pages;

        return (
            <>
                <ToastUI />
                <ConfirmDialog />
                <ConfirmPopup />
                <Loader />
                <Modals />
                <Specified />
                <Editor id="hidden-editor" /> {/* специально, ьчтобы отправить нужный для рендера запрос заблаговременно */}
            </>
        );
    }),
);

export default Root;
